'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('textAlign', 'align');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/text-align.js
// module id = 1063
// module chunks = 168707334958949